import { createContext, useContext, useEffect } from 'react';

/**
 * Название текущего экрана.
 *
 * Вложенные маршруты рендерятся в Outlet родителя, а заголовок страницы живёт
 * в макете родителя — он про дочерний экран ничего не знает. Через этот контекст
 * экран сообщает своё название наверх, и скрытый h1 называет именно его,
 * а не раздел целиком. Вне макета контекст пустой, хук работает как раньше.
 */
export const PageTitleContext = createContext<((title?: string) => void) | null>(null);

export const usePageTitle = (title?: string) => {
  const publish = useContext(PageTitleContext);

  useEffect(() => {
    if (title) {
      document.title = `${title} | IHCL LMS`;
    }
    publish?.(title);

    return () => {
      document.title = 'IHCL LMS';
      publish?.(undefined);
    };
  }, [title, publish]);
};
